const counterPartAccountActions = {
  CREATE: 'create',
  ACTIVATE: 'activate',
  DISABLE: 'disable',
  UNLOCK_PROJECTS: 'unlock_projects',
  RESETPASSWORD: 'passwordReset'
};

export default counterPartAccountActions;
